export default __webpack_public_path__ + "static/media/Infiniti-favicon.900c2c03.ico";